import jQuery from "jquery";

import "animate.css";
import "bootstrap/dist/css/bootstrap.min.css";

import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/tooltip";

jQuery("[data-toggle=dropdown]").dropdown();
jQuery("body").tooltip({ selector: "[data-toggle=tooltip]" });

import { sidebar } from "./frames/sidebar";
import { topbar } from "./frames/topbar";
import "./main.css";

const frames = { sidebar, topbar };
const frame = "sidebar";

export const view = ({ translations }) => (state, actions) => {
  state.language = state.language.toLowerCase();
  return frames[frame]({
    actions,
    state,
    translations: translations,
  });
};
